/* eslint-disable import/no-cycle */
/* eslint-disable func-names */
import { ALERTAS_ROUTE } from "constants/apiRoutes";
import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import api from "../../../services/api";
import { INITIAL_STATE_VALUES, Types } from "../../ducks/alertas/audiencia";
import executeAction from "../comum/executeAction";

function getCrepdecsFromGeo(municipios) {
	if (!municipios) return [];

	const listaCrepdecs = municipios.map(item => item.crepdec);

	const getUniqueValues = [
		...new Set(listaCrepdecs.map(item => item.id))
	].map(id => listaCrepdecs.find(a => a.id === id));

	return getUniqueValues;
}

function getMunicipiosFromGeo(municipios) {
	if (!municipios) return [];

	const listaMunicipios = municipios.map(item => ({
		nome: item.nome,
		codigoIbge: item.codigoIbge
	}));
	return listaMunicipios;
}

function* asyncAudienciaBuscarPorAlertaId(action) {
	yield executeAction(function*() {
		const { alertaId, callback } = action;

		const { data } = yield call(
			api.get,
			ALERTAS_ROUTE.FIND_BY_ID.replace("{alertaId}", alertaId)
		);

		const { municipios } = data.geo ? data.geo : [];
		const arrayCrepdecs = getCrepdecsFromGeo(municipios);
		const arrayMunicipios = getMunicipiosFromGeo(municipios);

		let { emissaoAlerta } = data;
		emissaoAlerta = emissaoAlerta || INITIAL_STATE_VALUES.emissaoAlerta;
		emissaoAlerta.alertaId = data.id;
		emissaoAlerta.alertaStatus = data.statusAtualAlerta;

		const { dadoParametrizado } = data;

		yield put({
			type: Types.AUDIENCIA_BUSCAR_POR_ALERTA_ID_REDUCER,
			emissaoAlerta,
			arrayCrepdecs,
			arrayMunicipios,
			dadoParametrizado,
			data
		});

		if (callback) callback(false);
	}, Types.AUDIENCIA_BUSCAR_POR_ALERTA_ID);
}

function* takeAudienciaBuscarPorAlertaId() {
	yield takeLatest(
		Types.AUDIENCIA_BUSCAR_POR_ALERTA_ID,
		asyncAudienciaBuscarPorAlertaId
	);
}

export default function* root() {
	yield all([fork(takeAudienciaBuscarPorAlertaId)]);
}
